import ManualOperationPage from '../pages/manual-operation/page'

export const manualOperationRoutes = [
  { path: '/manual-operation', element: <ManualOperationPage /> },
]
